import { AfterViewInit, ApplicationRef, Component, inject, OnInit } from '@angular/core'
import { NavigationStart, Router, RouterOutlet } from '@angular/router'
import { Store } from '@ngrx/store'
import { filter, first } from 'rxjs'
import { resetEmployeeState } from './store/user/user.actions'
import { resetBusinessState } from './store/business/business.actions'
import { resetDepartmentState } from './store/department/department.actions'
import { resetDesignationState } from './store/designation/designation.actions'
import { FirebaseService } from './services/firebase.service'
import { PushNotificationService } from './services/push-notification.service'
import { Title } from '@angular/platform-browser'
import { environment } from '../environments/environment'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { logoutSuccess } from './store/auth/auth.actions'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'AVR HRMS'

  private router = inject(Router)
  private store = inject(Store)

  constructor(
    private firebaseService: FirebaseService,
    private pushService: PushNotificationService,
    private titleService: Title,
    private modalService: NgbModal,
    appRef: ApplicationRef
  ) {
    window.addEventListener('storage', event => {
      if (event.key === 'logout-event') {
        this.store.dispatch(
          logoutSuccess({
            success: 'Logged out'
          })
        )

        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        localStorage.removeItem('user')
        localStorage.removeItem('permissions')
        localStorage.removeItem('subscription')
        localStorage.removeItem('fcmToken')

        localStorage.clear()

        setTimeout(() => {
          localStorage.removeItem('logout-event')
        }, 1000)
      }
    })
    this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(() => {
      // Dispatch your reset actions here
      this.store.dispatch(resetBusinessState())
      this.store.dispatch(resetEmployeeState())
      this.store.dispatch(resetDepartmentState())
      this.store.dispatch(resetDesignationState())
      // this.firebaseService.requestPermission()
      // this.firebaseService.listenForMessages()
      this.titleService.setTitle(environment.title)
      // Add more resets if needed: this.store.dispatch(resetEmployeeState());
      this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          this.modalService.dismissAll()
        }
      })
    })
    appRef.isStable.pipe(first(stable => stable)).subscribe(() => {
      document.getElementById('pre-hydration-loader')?.remove()
    })
  }

  ngOnInit() {
    this.handleDomainRouting()
    this.firebaseService.requestPermission().then(token => {
      if (token) {
        // Send FCM token to backend here
        // console.log('FCM Token app component:', token)
      }
    })

    this.firebaseService.listenForMessages()
    this.requestNotificationPermission()
  }

  requestNotificationPermission() {
    Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        // console.log('Notification permission granted.')
        this.pushService.requestSubscription()
      } else {
        // console.warn('Notification permission denied.')
      }
    })
  }

  private handleDomainRouting() {
    const host = window.location.hostname
    const path = window.location.pathname
    const port = window.location.port

    const isWebsite = host === 'avrhrms.com' || port === '4200'
    // const isHrms = host === 'app.avrhrms.com'
    const isHrms =
      host === 'app.avrhrms.com' ||
      host.endsWith('-app.avrhrms.com') ||
      port === '4300' ||
      port === '4206' ||
      port === '4208' ||
      port === '4210'

    // WEBSITE DOMAIN
    if (isWebsite) {
      return // normal website flow
    }

    // HRMS DOMAIN
    if (isHrms) {
      // root redirect
      if (path === '/' || path === '') {
        this.router.navigateByUrl('/auth/login')
        return
      }

      // optional safety fallback
      // if (!path.startsWith('/auth') && !path.startsWith('/user') && !path.startsWith('/company')) {
      //   this.router.navigateByUrl('/auth/login')
      // }
    }
  }
  ngAfterViewInit() {
    setTimeout(() => document.getElementById('pre-hydration-loader')?.remove(), 3000)
  }
}
